import React, { FC } from 'react';
import { isBloggerBusiness } from '../../../utils/accessService';
import { addProtocol } from '../../../utils/addProtocol';
import { buildImageSource, buildImageSourceSet } from '../../../utils/buildImageSource';
import { getDomainFromUrl } from '../../../utils/getDomainFromUrl/getDomainFromUrl';
import { useTranslation } from '../../../utils/useTranslation';
import { IconProduct } from '../../icon/IconProduct';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Image } from '../../media/Image';
import { MediaCover } from '../../media/MediaCover';
import { Price } from '../../price/Price';
import { Typography } from '../../typography/Typography';
import { ProductMonetization } from '../ProductMonetization/ProductMonetization';
import { Card, Title } from './styles';
import { PostProductCardProps } from './types';

export const PostProductCard: FC<PostProductCardProps> = ({
    product,
    business,
    onProductClick,
}) => {
    const t = useTranslation();
    const {
        oldPriceInfo,
        priceInfo,
        content,
        title,
        url,
        id,
        monetizationEnabled,
        fintechDiscount,
    } = product;

    const media = content[0]?.media;

    const domain = isBloggerBusiness(business?.type)
        ? getDomainFromUrl(product.originalUrl)
        : undefined;

    return (
        <Card as="a" href={addProtocol(url)} onClick={() => onProductClick(id, url)}>
            {monetizationEnabled ? (
                <Box position="absolute" top={1} left={1} zIndex={1}>
                    <ProductMonetization color="white" />
                </Box>
            ) : null}
            <MediaCover ratio={1} overflow="hidden" borderRadius="20px">
                <Flex
                    alignItems="center"
                    justifyContent="center"
                    backgroundColor="var(--background-primary)"
                >
                    {media ? (
                        <Image
                            objectFit="contain"
                            width="100%"
                            height="100%"
                            src={buildImageSource(media)}
                            srcSet={buildImageSourceSet(media)}
                        />
                    ) : (
                        <IconProduct size={72} color="var(--control-secondary-background)" />
                    )}
                </Flex>
            </MediaCover>
            <Box p={1}>
                <Title variant="body2" weight="regular">
                    {t(title)}
                </Title>
                <Price
                    priceInfo={priceInfo}
                    oldPriceInfo={oldPriceInfo}
                    fintechDiscount={fintechDiscount}
                    variant="body"
                    hideOldPrice
                    showOldPriceBadge
                    fintechDiscountOptions={{ compact: true }}
                />
                {domain ? (
                    <Typography variant="caption" color="secondary" mt={0.5}>
                        {domain}
                    </Typography>
                ) : null}
            </Box>
        </Card>
    );
};
